import React from "react";
import logo from "../assets/diagorisk-logo-long.png"; // <- mets ton fichier logo ici

export default function Header({ onExport, exporting }) {
  return (
    <header className="diagoeau-header">
      <img src={logo} alt="DiagoRisk" className="diagoeau-logo" />
      {/* <button className="diagoeau-btn" onClick={onExport} disabled={exporting}>
        {exporting ? "Génération…" : "Enregistrer les graphiques (PPTX)"}
      </button> */}
    </header>
  );
}
